import store from '../../store'
import { goTo, query as webxQuery, xenv, is } from '@didi/webx-js'
import { GlobalEnv, URLQueries } from '../webx'
import { getUrlBizExtraParams } from '../webx/global_env/url_query'
import { isDyProgramH5 } from '@/lib/js/env'
import { getExtraInfoOnQuery, transformUrl } from './util'
import { restoreTokenToUrl } from './token-guard'

const Query = webxQuery()

export function navigateTo({ pathname, query = {}, openPage = false }) {
  if (!pathname) {
    return
  }
  const adParams = getUrlBizExtraParams()
  // 抖音模式下跳小程序首页
  if (isDyProgramH5() && pathname === 'index') {
    restoreTokenToUrl()
    goTo({
      path: '/pages/home/index',
      params: adParams,
      extParams: {
        moveType: 2, // 0（navigateTo）、1（redirectTo）、2（reLaunch）
      },
    })
    return
  }
  query = Object.assign({}, query, getExtraInfoOnQuery())
  if (isDyProgramH5()) {
    query = {
      ...query,
      biz_extra: JSON.stringify(adParams),
    }
  }
  query.lang = store.getters.lang
  query.openid = store.getters.openid
  query.from = store.getters.from
  query.dchn = store.getters.dchn
  if (xenv() !== 'passenger') {
    query.cityid = query.cityid || Query.cityid
  }
  const token = store.getters.userInfo.token
  if (is('miniprogram,hwfastapp') && !query.token && token) {
    query.token = token
  }
  if (Query.from === 'marking' || xenv() === 'yxwxmp') {
    Object.assign(query, {
      from: 'marking',
      token,
    })
  }
  if (Query.appversion) {
    query.appversion = Query.appversion
  }
  // let url = `./${pathname}.html`
  // if (openPage) {
  //   const _pathname = window.location.pathname.split('/')
  //   _pathname.pop()
  //   _pathname.push(`${pathname}.html`)
  //   url = `${window.location.origin}${_pathname.join('/')}`
  // }
  const url = transformUrl(pathname)
  setTimeout(() => {
    restoreTokenToUrl()
    goTo({
      url: url,
      params: query,
      extParams: {
        h5JumpMethod: openPage ? 'openPage' : 'href',
        sameProduct: url.indexOf('quartz-mall') > -1,
      },
    })
  }, 0)
}

export function navigateToWebx({ pathname, query = {}, openPage = false }) {
  if (!pathname) {
    return
  }
  query.lang = GlobalEnv.lang
  if (!query.openid) {
    query.openid = GlobalEnv.openid
  }
  query.from = GlobalEnv.from
  query.dchn = URLQueries.getQuery('dchn')
  if (xenv() !== 'passenger') {
    query.cityid = GlobalEnv.locationInfo.cityId
  }
  if (Query.from === 'marking' || xenv() === 'yxwxmp') {
    Object.assign(query, {
      from: 'marking',
      // token: store.getters.userInfo.token
      token: GlobalEnv.loginInfo.token,
    })
  }
  if (
    is('miniprogram,hwfastapp') &&
    !query.token &&
    GlobalEnv.loginInfo.token
  ) {
    query.token = GlobalEnv.loginInfo.token
  }
  if (Query.appversion) {
    query.appversion = Query.appversion
  }
  // let url = `./${pathname}.html`
  // if (openPage) {
  //   const _pathname = window.location.pathname.split('/')
  //   _pathname.pop()
  //   _pathname.push(`${pathname}.html`)
  //   url = `${window.location.origin}${_pathname.join('/')}`
  // }
  const url = transformUrl(pathname)
  setTimeout(() => {
    restoreTokenToUrl()
    goTo({
      url: url,
      params: query,
      extParams: {
        h5JumpMethod: openPage ? 'openPage' : 'href',
        sameProduct: url.indexOf('quartz-mall') > -1,
      },
    })
  }, 0)
}
